import React from 'react';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import css from './index.module.scss';

const CountDown = ({ duration = 7, size = 80, strokeWidth = 8, onComplete }) => {
  return (
    <CountdownCircleTimer
      isPlaying
      duration={duration}
      colors={'#E4002B'}
      size={size}
      strokeWidth={strokeWidth}
      onComplete={onComplete}
      rotation={'counterclockwise'}
    >
      {({ remainingTime }) => (
        <div className={css.timerContent}>
          <div className={css.time}>{remainingTime}</div>
          <div className={css.text}>seconds</div>
        </div>
      )}
    </CountdownCircleTimer>
  );
};

export default CountDown;
